
const digest = '186d1b69fadbae68a7ba4d40b48449abb0417cc0b943b4f3d3706f8f30700f9d';
const classes = {"wrapper":"_wrapper_192ur_1","item":"_item_192ur_6"};
const css = `._wrapper_192ur_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
}
._wrapper_192ur_1 ._item_192ur_6 {
  font-weight: 600;
  font-size: 14px;
  padding: 8px;
  background-color: #dfe7ee;
  margin-bottom: 5px;
  color: #000000;
}
._wrapper_192ur_1 ._item_192ur_6 span {
  font-weight: 400;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  